<div class="d-flex gap-2 flex-column h-100">
  <div class="d-flex justify-content-between align-items-center template-position z-index-9">
    <div>
      <h6>{{ 'quick_replies' | translate }}</h6>
    </div>
    <div>
      <app-button btnType="icon" (click)="close('')"><app-icon>close</app-icon></app-button>
    </div>
  </div>
  @if (!templates.length) {
    <div>
      <div>
        <label class="text-template">{{
          'use_quick,_ready_to_use_answers_to_the_most_frequently_asked_questions_from_customers' | translate
        }}</label>
      </div>
      <div>
        <span class="d-flex align-items-center text-wrap"
          ><app-icon>check</app-icon>
          {{ 'save_an_already_sent_message_as_a_quick_reply_by_right-clicking_on_the_message' | translate }}</span
        >
      </div>
      <div>
        <span class="d-flex align-items-center"
          ><app-icon class="d-flex align-items-center">check</app-icon
          >{{ 'create_a_new_one_in_chat_settings' | translate }}</span
        >
      </div>
    </div>
  }

  @if (templates.length) {
    <div class="overflow-auto crm-scroll">
      @for (template of templates; track template) {
        <div class="list click-css" mat-ripple (click)="close(template)">
          <div class="my-2">{{ template.text }}</div>
          <mat-divider></mat-divider>
        </div>
      }
    </div>
  }
</div>
